import { useDispatch, useSelector } from 'react-redux'
import {
    resetAccreditationCheckState,
    selectTeacherAccreditationLive,
    selectTeacherEmploymentSettings,
    setAccreditationCheckState,
    syncAccreditationSettings,
} from '../../../../redux/teacherSlice'
import useAccreditationConfig, {
    createKey,
} from '../../../../hooks/useAccreditationConfig'
import { AccreditationDocument } from '../../../../redux/types'
import { memo, useEffect, useMemo } from 'react'
import { isDocExpired } from '../../../../helpers/utils'
import { EmploymentSetting } from '../../../../firebase/types-teacher'
import { positiveStates } from '../../MyAccountPage/AccountStatePages/incompleteComponents/accordions'
import { FieldState_v2 } from '../../../../schemas/teacherReg'

const TeacherOnboardingComponent = memo(() => {
    // const accountState = useSelector(selectTeacherAccountState)

    // Don't run onboarding check logic if approved
    // if (
    //     accountState.status !== 'success' ||
    //     accountState.data === 'approved' ||
    //     accountState.data === 'onHold'
    // ) {
    //     return null
    // }

    return (
        <>
            <AccreditationCheckWrapper />
        </>
    )
})

const AccreditationCheckWrapper = () => {
    const dispatch = useDispatch()
    const employmentSettings = useSelector(selectTeacherEmploymentSettings)
    const settingKeys = useMemo(
        () =>
            employmentSettings.status === 'success'
                ? Object.values(employmentSettings.data || {})
                      .map((el) => createKey(el))
                      .filter((key): key is string => Boolean(key))
                : [],
        [employmentSettings]
    )

    useEffect(() => {
        if (employmentSettings.status !== 'success') return
        dispatch(syncAccreditationSettings({ activeKeys: settingKeys }))
    }, [dispatch, employmentSettings.status, settingKeys])

    useEffect(() => {
        if (employmentSettings.status !== 'success') return
        return () => {
            dispatch(resetAccreditationCheckState())
        }
    }, [dispatch, employmentSettings.status])

    if (employmentSettings.status !== 'success') return null

    return Object.values(employmentSettings.data || {}).map((el) => (
        <AccreditationCheck
            key={`${el.locationState}:${el.type}`}
            setting={el}
        />
    ))
}

const AccreditationCheck = ({ setting }: { setting: EmploymentSetting }) => {
    const checkKey = createKey(setting)

    const config = useAccreditationConfig(setting)
    const accreditation = useSelector(selectTeacherAccreditationLive)
    const dispatch = useDispatch()

    // Record of type as key and whether optional or not by value
    // `true` => optional `false` => mandatory
    const docIds = useMemo(() => {
        if (config.status !== 'success') return {}
        return (
            Object.values(config.data)
                // .filter((doc) => !doc.optional)
                .reduce(
                    (a, c) => ({ ...a, [c.type]: Boolean(c.optional) }),
                    {} as Record<string, boolean>
                )
        )
        // .map((doc) => doc.type)
        // .filter((docType): docType is string => !!docType)
    }, [config.data, config.status])

    const ready = useMemo(() => {
        if (config.status !== 'success') return false
        if (accreditation.status !== 'success') return false

        if (Object.values(docIds).filter((e) => !e).length === 0) return true

        const accreditationDocs = Object.values(
            accreditation.data || {}
        ) as AccreditationDocument[]

        return Object.entries(docIds)
            .filter(([_, isOptional]) => !isOptional)
            .every(([type]) =>
                accreditationDocs.some(
                    (doc) =>
                        doc.accreditationType === type &&
                        !isDocExpired(doc.expiryDate) &&
                        positiveStates.has(doc.state as FieldState_v2 || 'incomplete')
                )
            )
    }, [accreditation.data, accreditation.status, config.status, docIds])

    useEffect(() => {
        dispatch(
            setAccreditationCheckState({
                key: checkKey,
                ready,
                docIds,
            })
        )
    }, [checkKey, dispatch, ready, docIds])

    return null
}

export default TeacherOnboardingComponent
